import s from './BannerTitle.module.css';

interface BannerTitleProps {
  children: string;
}

const BannerTitle = ({ children }: BannerTitleProps) => {
  return <h2 className={s.title}>{children}</h2>;
};

export { BannerTitle };
